export const POST_VOLUNTEER_BEGIN = "POST_VOLUNTEER_BEGIN";
export const POST_VOLUNTEER_SUCCESS = "POST_VOLUNTEER_SUCCESS";
export const POST_VOLUNTEER_ERROR = "POST_VOLUNTEER_ERROR";

export const GET_VOLUNTEER_BEGIN = "GET_VOLUNTEER_BEGIN";
export const GET_VOLUNTEER_SUCCESS = "GET_VOLUNTEER_SUCCESS";
export const GET_VOLUNTEER_ERROR = "GET_VOLUNTEER_ERROR";

